<!--
  @description: 首页-待支付合同押金列表组件
  @filePath:src\modules\transport\views\manageDesk\components\NoPaymentContractDepositTable.vue
-->
<template>
  <el-table
    :data="tableData"
    :loading="loading"
    :height="175"
    empty-text="暂无数据"
    stripe
    show-overflow-tooltip
    class="custom-table"
    style="width: 100%"
  >
    <el-table-column show-overflow-tooltip prop="supCashNo" label="押金单号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="mdcoContractNo" label="合同编号"></el-table-column>
    <el-table-column show-overflow-tooltip prop="budgetAmt" label="押金金额"></el-table-column>
    <el-table-column show-overflow-tooltip prop="paymentAmount" label="已支付金额"></el-table-column>
    <el-table-column label="操作" width="180">
      <template slot-scope="scope">
        <el-button :class="'bigData-btn-view-' + tabsCode" @click="toView(scope.row)" type="text"
          >去查看</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { getDepositLists } from '@/modules/transport/bms/api/depositApi';
import { moduleList } from '@/modules/transport/views/manageDesk/todoList';

export default {
    inject: ['linkToPointPage'],
    data() {
        return {
            loading: false,
            tableData: [],
            moduleList,
            signTabsData: moduleList.find(item => item.code === 'signTabs')
        };
    },
    props: {
        tabsCode: {
            type: String,
            default: 'noPaymentContractDeposit'
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        toView(row) {
            const pageParams = {
                path: '/bms/deposit',
                query: {
                    supCashNo: row.supCashNo,
                    from: 'todoList'
                }
            };
            this.linkToPointPage && this.linkToPointPage(pageParams);
            this.$emit('toView', row);
        },
        getData() {
            const params = { pageNo: 1, pageSize: 200, statues: '20,30', suppliersCashType: '1' }; // 状态为待支付和部分支付
            this.loading = true;
            getDepositLists(params).then(res => {
                if (res && res.code === '0') {
                    for (const item of this.signTabsData.childList) {
                        if (item.code === this.tabsCode) {
                            this.$set(item, 'num', res.data.totalCount || '0');
                            break;
                        }
                    }
                    this.tableData = res.data.list.map(item => {
                        // 已支付金额（现汇金额toAmt +应收转押金金额payChangeCashAmt）
                        item.paymentAmount = (item.toAmt + item.payChangeCashAmt) || 0;
                        return item;
                    });
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="less" scoped></style>
